<template>
	<div class="closeapp-logo">
		<v-img max-width="300" width="" src="/assets/Closeapp-logo.png"
		/>
	</div>
</template>

<script>
export default {
	name: "CloseAppLogo",
	// accepts color props as dark or light
	props: { color: String },
};
</script>
